import React, { useEffect, useState, Suspense } from "react";


import { Helmet } from 'react-helmet';

import DateFnsUtils from "@date-io/date-fns";
import ruLocale from "date-fns/locale/ru";
import enLocale from "date-fns/locale/en-GB/index";

import { ThemeProvider as MuiThemeProvider, StylesProvider } from "@material-ui/core/styles";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { ThemeProvider } from "styled-components";


import maTheme from "./theme";
import RouterConfig from "./router";
import { YMInitializer } from "react-yandex-metrika";
import ReactPixel from 'react-facebook-pixel';
import { useStores } from "./hooks";
import { observer } from "mobx-react";
import rootStore from "./stores";
import { StoreProvider } from "./contexts";


const App = () => {
    const { generalStore } = useStores();
    const [locale, setLocale] = useState<Locale>(enLocale);


    useEffect(() => {
        if (!generalStore) return;
        const locale = generalStore?.locale?.id !== 'ru' ? enLocale : ruLocale;
        setLocale(locale);
    }, [generalStore])

    useEffect(() => {
        ReactPixel.init('2621098511524573');
    }, []);

    return (
        <React.Fragment>
            <Helmet
                titleTemplate="%s"
                defaultTitle="Личный кабинет restify.one"
            />
            <StylesProvider injectFirst>
                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                        <MuiThemeProvider theme={maTheme[0]}>
                            <ThemeProvider theme={maTheme[0]}>
                                {RouterConfig()}
                            </ThemeProvider>
                        </MuiThemeProvider>
                    </MuiPickersUtilsProvider>
            </StylesProvider>
            <YMInitializer accounts={[83714692]} options={{ webvisor: true }}/>
        </React.Fragment>
    );
}

const AppT = observer(App)
export default () => {
    return <StoreProvider store={rootStore}>
        <Suspense fallback="loading">
            <AppT/>
        </Suspense>
    </StoreProvider>
}
